/**
 * Loume — Handy-Menü „Glasblatt“: <lo-menue-blatt>
 * =================================================
 *
 * Umhüllt den Inhalt des Blatts (snippets/loume-menue-blatt.liquid). Öffnen,
 * Schließen, Fokusfalle, Esc und Scrollsperre bleiben bei Dawn (global.js,
 * HeaderDrawer); unter der Leiste schließt ein Tipp über Dawns unsichtbaren
 * Schleier. Dieses Element ergänzt nur:
 *
 *   - .loume-blatt--js am Blatt: Erst damit gilt das Aufrollen samt
 *     Ausgangszustand (unsichtbar). Dawn setzt <html class="js"> fest ins
 *     HTML, darauf kann sich „ohne JavaScript“ nicht verlassen — ohne Skript
 *     steht das Blatt beim Öffnen einfach da. Ist das Menü beim Laden des
 *     Skripts schon offen, kommt die Klasse erst nach dem Schließen.
 *   - html.lo-menue-offen, solange das Menü offen ist (blendet die
 *     Superchat-Blase aus, loume-menue-blatt.css);
 *   - ein Tipp neben oder über die Leiste (Seitenränder, TV-Leiste) schließt
 *     das Menü, statt dort etwas auszulösen — außerhalb der Kopfleiste, bei
 *     offenem Menü, in der Einfangphase;
 *   - die Länderwahl schickt sich beim Umschalten per Tipp oder Klick
 *     selbst ab; mit der Tastatur (Pfeiltasten) nicht — dann erscheint der
 *     Knopf „Land/Region aktualisieren“, den es ohne Skript immer gibt
 *     (WCAG 3.2.2: Pfeiltasten dürfen nicht die Seite neu laden);
 *   - solange das Menü offen ist, ist die Seite dahinter inert (#MainContent,
 *     Footer, übrige Kopf-Sections wie die TV-Leiste): Safari-Tab,
 *     VoiceOver und Co. bleiben im Menü. Dawns Fokusfalle hält in Safari
 *     nicht (Tab springt dort nur zwischen Formularfeldern);
 *   - ein Tipp auf den Warenkorb schließt das Menü, bevor der Warenkorb
 *     aufgeht (sonst stand es danach offen, der Fokus außerhalb);
 *   - kurze Bildschirme: passt das Blatt nicht, .loume-blatt--eng (Karten
 *     quadratisch); rollt es dann noch, .loume-blatt--mehr (Auslauf unten),
 *     bis ans Ende gerollt ist;
 *   - die App-Zeile (a[data-lo-app]) führt auf iPhone und iPad direkt in den
 *     App Store, unter Android direkt zu Google Play, nicht über
 *     /pages/appredirect (Gründer, 28.09.2026). Das href wird beim Aufbau
 *     gesetzt, nicht erst beim Tippen. Sonst (Computer, unbekannt, ohne
 *     Skript) bleibt der Link aus dem Liquid.
 *
 * Die Filme der Karten steuert <lo-menue-video> (loume-produktmenue.js), den
 * Dimmwert loume-kopf-kontrast.js.
 */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('lo-menue-blatt')) return;

  // 'ios', 'android' oder null. Android zuerst, wie /pages/appredirect.
  // iPadOS meldet sich in Safari seit iPadOS 13 als Mac („Macintosh“); ein
  // Mac hat keinen Touchscreen (maxTouchPoints 0), ein iPad 5.
  function plattform() {
    var ua = navigator.userAgent || '';
    if (/android/i.test(ua)) return 'android';
    if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
    if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
    return null;
  }

  // Shopify liefert allen Geräten dasselbe HTML (Zwischenspeicher), also
  // entscheidet der Browser. Ohne passende Adresse bleibt der Rückfall-Link.
  function appLinksSetzen(wurzel) {
    var art = plattform();
    if (!art) return;
    var links = wurzel.querySelectorAll('a[data-lo-app]');
    for (var i = 0; i < links.length; i++) {
      var ziel = links[i].getAttribute(art === 'ios' ? 'data-app-ios' : 'data-app-android');
      if (ziel) links[i].setAttribute('href', ziel);
    }
  }

  class LoumeMenueBlatt extends HTMLElement {
    connectedCallback() {
      if (this.verbunden) return;
      this.verbunden = true;

      // Zuerst, damit die Zeile schon richtig zeigt, bevor jemand tippen kann.
      appLinksSetzen(this);

      var details = this.closest('details');
      var blatt = this.closest('.loume-blatt');
      if (!details) return;
      this.details = details;
      var html = document.documentElement;

      function bereit() {
        if (blatt && !details.open) blatt.classList.add('loume-blatt--js');
      }

      var kopf = details.closest('.section-header') || details.closest('.header-wrapper');
      var summary = details.querySelector(':scope > summary');
      var daneben = function (ereignis) {
        if (!details.open || !details.classList.contains('menu-opening')) return;
        var ziel = ereignis.target;
        if (!ziel || !ziel.closest || (kopf && kopf.contains(ziel))) return;
        // Was über dem Dimmer liegt, bleibt bedienbar (Cookie-Banner, Vorschau-Leiste).
        if (ziel.closest('#shopify-pc__banner, #shopify-pc__prefs, cart-drawer, #superchat-widget-root, #PBarNextFrameWrapper, #preview-bar-iframe')) return;
        ereignis.preventDefault();
        ereignis.stopPropagation();
        if (summary) summary.click();
      };

      // Warenkorb bei offenem Menü: erst das Menü schließen (Einfangphase,
      // vor Dawns Warenkorb-Skript), dann geht der Warenkorb auf.
      var zumWarenkorb = function (ereignis) {
        if (!details.open) return;
        var ziel = ereignis.target;
        if (ziel && ziel.closest && ziel.closest('#cart-icon-bubble') && summary) summary.click();
      };

      // Die Seite hinter dem offenen Menü: inert. Nur, was nicht schon inert
      // war, und nur das wird beim Schließen wieder freigegeben.
      var sperren = function (an) {
        var teile = document.querySelectorAll(
          '#MainContent, .shopify-section-group-footer-group, .shopify-section-group-header-group'
        );
        for (var i = 0; i < teile.length; i++) {
          var teil = teile[i];
          if (kopf && (teil === kopf || teil.contains(kopf))) continue;
          if (an) {
            if (teil.inert) continue;
            teil.inert = true;
            teil.setAttribute('data-lo-menue-inert', '');
          } else if (teil.hasAttribute('data-lo-menue-inert')) {
            teil.inert = false;
            teil.removeAttribute('data-lo-menue-inert');
          }
        }
      };

      // Höhe des Inhalts aus dem Layout (offsetTop/offsetHeight), nicht aus
      // scrollHeight: Die Stufen stehen beim Aufrollen 10px tiefer
      // (transform), das zählt scrollHeight mit — jedes Blatt galt sonst als
      // zu lang. Erstes und letztes Kind liegen im selben offsetParent, ein
      // Rollen verschiebt beide gleich.
      var rollbar = this;
      var bedarf = function () {
        var erstes = rollbar.firstElementChild;
        var letztes = rollbar.lastElementChild;
        if (!erstes || !letztes) return rollbar.scrollHeight;
        var stil = getComputedStyle(rollbar);
        return (
          letztes.offsetTop + letztes.offsetHeight - erstes.offsetTop +
          parseFloat(stil.paddingTop) + parseFloat(stil.paddingBottom)
        );
      };
      var mehrPruefen = function () {
        if (!blatt) return;
        blatt.classList.toggle(
          'loume-blatt--mehr',
          details.open && rollbar.scrollTop + rollbar.clientHeight < bedarf() - 4
        );
      };
      var platzPruefen = function () {
        if (!blatt || !details.open) return;
        blatt.classList.remove('loume-blatt--eng');
        if (bedarf() > rollbar.clientHeight + 1) blatt.classList.add('loume-blatt--eng');
        mehrPruefen();
      };
      var beiGroesse = function () {
        if (details.open) platzPruefen();
      };
      rollbar.addEventListener('scroll', mehrPruefen, { passive: true });

      this.umschalten = function () {
        var offen = details.open;
        html.classList.toggle('lo-menue-offen', offen);
        if (offen) {
          document.addEventListener('click', daneben, true);
          document.addEventListener('click', zumWarenkorb, true);
          window.addEventListener('resize', beiGroesse, { passive: true });
        } else {
          document.removeEventListener('click', daneben, true);
          document.removeEventListener('click', zumWarenkorb, true);
          window.removeEventListener('resize', beiGroesse);
        }
        sperren(offen);
        if (offen) platzPruefen();
        else mehrPruefen();
        bereit();
      };
      this.daneben = daneben;
      this.zumWarenkorb = zumWarenkorb;
      this.beiGroesse = beiGroesse;
      this.sperren = sperren;
      details.addEventListener('toggle', this.umschalten);
      // Zurück aus dem Verlauf (bfcache): Zustand neu abgleichen.
      this.beiPageshow = this.umschalten;
      window.addEventListener('pageshow', this.beiPageshow);
      this.umschalten();

      var form = this.querySelector('.loume-blatt__land-form');
      if (form) {
        // Zeiger (Tipp, Klick) schickt sofort ab, Tastatur nicht.
        var zeiger = false;
        form.addEventListener('pointerdown', function () {
          zeiger = true;
        }, true);
        form.addEventListener('keydown', function () {
          zeiger = false;
        }, true);
        form.addEventListener('change', function (ereignis) {
          var feld = ereignis.target;
          if (!feld || feld.name !== 'country_code' || !feld.checked) return;
          if (!zeiger) {
            form.classList.add('ist-geaendert');
            return;
          }
          zeiger = false;
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        });
      }
    }

    disconnectedCallback() {
      if (this.details && this.umschalten) this.details.removeEventListener('toggle', this.umschalten);
      if (this.daneben) document.removeEventListener('click', this.daneben, true);
      if (this.zumWarenkorb) document.removeEventListener('click', this.zumWarenkorb, true);
      if (this.beiGroesse) window.removeEventListener('resize', this.beiGroesse);
      if (this.beiPageshow) window.removeEventListener('pageshow', this.beiPageshow);
      if (this.sperren) this.sperren(false);
      document.documentElement.classList.remove('lo-menue-offen');
      this.verbunden = false;
    }
  }

  customElements.define('lo-menue-blatt', LoumeMenueBlatt);
})();
